import { Deserializable } from '../protocols/deserializable';
import { SubmissionAttachment } from './submission-attachment';

export class SubmissionCreated implements Deserializable {
  public id: number = -1;
  public memberId: number = -1;
  public submissionTypeId: number = -1;
  public submissionTypeName: string = '';
  public statusId: number = -1;
  public status: string = '';
  public idPrefix: string = '';
  public idSuffix: string = '';
  public createdDate: string = '';
  public completedDate: string = '';
  public expiringSoon: boolean = false;
  public comment: string = '';
  public attachments: SubmissionAttachment[] = [];

  onDeserialize() {}
}
